<ng-container *ngIf="{
    row: columnData | async
  } as $">

  <div class="flex align-items-center">

    <div *ngIf="$.row.payment_status && isfailedPayment($.row)" class="flex align-items-center">
      <strong class="block p-error">{{ $.row.occurance_invoice_id > 0 ? ($.row.payment_amount_in_minor_currency | currencyformat) : $.row.invoice_amount_in_minor_currency | currencyformat}}</strong>
      <p-badge
        *ngIf="$.row.occurance_type != recurringOccuranceType.Recurring && $.row.occurance_type.toString() != recurringOccuranceType[recurringOccuranceType.Recurring]"
        [pTooltip]="getTooltipMessage($.row)" tooltipStyleClass="text-xs" severity="danger"
        styleClass="border-circle w-2rem h-2rem fa fa-exclamation-triangle flex align-items-center text-white justify-content-center ml-2"></p-badge>
      <p-badge
        *ngIf="$.row.occurance_type == recurringOccuranceType.Deposit || $.row.occurance_type.toString() == recurringOccuranceType[recurringOccuranceType.Deposit]"
        severity="danger"  value="DEPOSIT" styleClass="uppercase border-round text-xxs ml-2">
      </p-badge>
    </div>

    <div *ngIf="$.row.payment_status && isSuccessfulPayment($.row)" class="flex align-items-center">
      <strong class="block">{{ $.row.occurance_invoice_id > 0 ? ($.row.payment_amount_in_minor_currency | currencyformat) : $.row.invoice_amount_in_minor_currency | currencyformat}}</strong>

      <p-badge *ngIf="shouldShowIcon($.row)" [pTooltip]="getTooltipMessage($.row)" tooltipStyleClass="text-xs"
        severity="success" value=""
        styleClass="border-circle w-2rem h-2rem fa fa-exclamation-triangle text-white flex align-items-center justify-content-center ml-2">
      </p-badge>
      <p-badge *ngIf="$.row.occurance_type == recurringOccuranceType.Deposit || $.row.occurance_type.toString() == recurringOccuranceType[recurringOccuranceType.Deposit]"
        severity="success"  value="DEPOSIT" styleClass=" uppercase border-round text-xxs ml-2">
      </p-badge>
    </div>

    <div *ngIf="($.row.payment_status == paymentStatus.None || $.row.payment_status.toString() == paymentStatus[paymentStatus.None]) ||
      ($.row.payment_status == paymentStatus.Initiated || $.row.payment_status.toString() == paymentStatus[paymentStatus.Initiated])"
      class="flex align-items-center">
      <span class="block opacity-50">{{ $.row.occurance_invoice_id > 0 ? ($.row.payment_amount_in_minor_currency | currencyformat) : $.row.invoice_amount_in_minor_currency | currencyformat}}</span>
      <p-badge *ngIf="showBadgeInStatusNoneCase($.row.occurance_type)" [pTooltip]="getTooltipMessage($.row)"
        tooltipStyleClass="text-xs" severity="success" value=""
        styleClass="bg-transparent border-1 border-400 text-700 border-circle w-2rem h-2rem fa fa-exclamation-triangle flex align-items-center justify-content-center ml-2">
      </p-badge>
      <p-badge *ngIf="$.row.occurance_type == recurringOccuranceType.Deposit || $.row.occurance_type.toString() == recurringOccuranceType[recurringOccuranceType.Deposit]"
        severity="success" value="DEPOSIT"
        styleClass="uppercase border-round surface-600 text-white text-xxs ml-2">
      </p-badge>
    </div>

  </div>
</ng-container>